import moment from 'moment';
import VueFormGenerator from 'vue-form-generator';

import helper from '@/components/new_deal/libs/helper';

export default {
  schema: {
    fields: [
      {
        type: 'currency',
        label: 'What is the Purchase Price of the Property?',
        model: 'price',
        attributes: {
          input: { 'data-lpignore': 'true' },
        },
        required: true,
        styleClasses: 'col-md-12',
        validator: [VueFormGenerator.validators.string, 'customDollarValidator'],
      },
      {
        type: 'select',
        label: 'Purchase Type',
        model: 'type',
        required: true,
        selectOptions: {
          noneSelectedText: '-',
        },
        values: [
          { name: 'Short Sale', id: 'short_sale' },
          { name: 'REO', id: 'reo' },
          { name: 'Standard Sale', id: 'standard_sale' },
          { name: 'For Sale by Owner', id: 'sale_by_owner' },
          { name: 'Probate', id: 'probate' },
        ],
        styleClasses: 'col-md-12',
        validator: VueFormGenerator.validators.string,
        onChanged(model) {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          model.shortSaleApproval = null;
          model.hasSecondLien = null;
          model.hasSecondLienApproval = null;
        },
      },
      {
        type: 'radios',
        label: 'Do you have written short sale approval?',
        model: 'shortSaleApproval',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.isShortSale(model);
        },
      },
      {
        type: 'radios',
        label: 'Does the property have an existing second lien?',
        model: 'hasSecondLien',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.isShortSale(model);
        },
      },
      {
        type: 'radios',
        label: 'Do you have a written short sale approval for the second lien?',
        model: 'hasSecondLienApproval',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
        visible(model) {
          return helper.hasSecondLien(model);
        },
      },
      {
        type: 'radios',
        label: 'Do you have a fully executed purchase contract?',
        model: 'contractExists',
        required: true,
        styleClasses: 'col-md-12 bool-radio',
        values: [
          { name: 'Yes', value: true },
          { name: 'No', value: false },
        ],
        validator: VueFormGenerator.validators.required,
      },
      {
        type: 'datePicker',
        label: 'What is your required closing date?',
        model: 'closingDate',
        required: true,
        styleClasses: 'col-md-12',
        options: {
          onlyDate: true,
          format: 'MM/DD/YYYY',
          formatted: 'll',
          color: '#3e88c9',
          buttonColor: '#3e88c9',
          minDate: moment().format('MM/DD/YYYY'),
          autoClose: true,
          label: 'Select Date',
        },
        validator: VueFormGenerator.validators.date,
      },
      {
        type: 'select',
        label: 'What is your exit strategy?',
        model: 'exitStrategy',
        required: true,
        selectOptions: {
          noneSelectedText: '-',
        },
        values: [
          { id: 'Sale', name: 'Sale' },
          { id: 'Refinance', name: 'Refinance' },
        ],
        validator: VueFormGenerator.validators.required,
      },
    ],
  },
  formOptions: {
    validationErrorClass: 'invalid-input',
    validateAfterChanged: true,
    fieldIdPrefix: 'purchase-',
  },
};



// WEBPACK FOOTER //
// ./src/components/new_deal/components/purchase/schema.js